import { render } from "./PixelStars.vue?vue&type=template&id=1f815ad1&scoped=true"
import script from "./PixelStars.vue?vue&type=script&lang=js"
export * from "./PixelStars.vue?vue&type=script&lang=js"

import "./PixelStars.vue?vue&type=style&index=0&id=1f815ad1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f815ad1"]])

export default __exports__